<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Newsletters</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home >
            </router-link>
            <span class="breadcrumb-item active">Newsletters</span>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="m-t-25">
            <div class="row">
              <div class="col-lg-12 add-form mb-4 d-flex justify-content-end">
                <button class="btn btn-info"  data-toggle="modal" data-target="#send-message-to-all">Send message to all</button>
              </div>
            </div>
            <section v-if="!isLoading">
              <div class="row">
                <div class="col-lg-12 add-form">
                  <input class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..."/>
                </div>
              </div>
              <table class="dataTable table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Email</th>
                    <th>Subscribed to</th>
                    <th>Date Added</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="newsletter in newsletters" :key="newsletter.id">
                    <td>{{newsletter.id}}</td>
                    <td>{{newsletter.email}}</td>
                    <td>{{newsletter.subscribe_to}}</td>
                    <td>{{newsletter.created_at}}</td>
                    <td>
                      <i class="fa fa-trash fa-icons" @click="deleteNewsletter(newsletter.id)" aria-hidden="true"></i>
                    </td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="send-message-to-all" tabindex="-1" role="dialog" aria-labelledby="send-message-to-all-label" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Send Message to All</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submit" id="send-message-to-all-form">
              <input type="text" v-model="bulkMessage.subject" placeholder="Enter subject here" class="form-control mb-2">
              <textarea rows="5" v-model="bulkMessage.message" placeholder="Enter message here" class="form-control"></textarea>
            </form>
          </div>
          <div class="modal-footer">
            <button type="submit" form="send-message-to-all-form" :disabled="this.$store.getters.apiStatus == 'loading'"
              class="btn btn-success">
              <div v-if="this.$store.getters.apiStatus != 'loading'">Send</div>
              <div v-else class="loader">
                <Loader></Loader>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Newsletter from '@/models/Newsletter'
export default {
  name: 'ContactQueries',
  data () {
    return {
      datatable: null,
      newsletters: [],
      bulkMessage: {
        subject: '',
        message: ''
      }
    }
  },
  computed: {
    isLoading () {
      if (this.newsletters.length === 0) { return this.$store.getters.apiStatus === 'loading' } else return false
    }
  },
  mounted () {
    let dataTableScript = document.createElement('script')
    dataTableScript.setAttribute('src', 'https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js')
    document.head.appendChild(dataTableScript)

    let naturalScript = document.createElement('script')
    naturalScript.setAttribute('src', 'https://cdn.datatables.net/plug-ins/1.10.16/sorting/natural.js')
    document.head.appendChild(naturalScript)
    this.fetchAllNewsletters()
  },
  methods: {
    fetchAllNewsletters () {
      this.newsletters = []
      this.$store.dispatch('fetchAllNewsletters')
        .then((result) => {
          result.data.newsletters.forEach(newsletter => {
            this.newsletters.push(new Newsletter(newsletter))
          })
          setTimeout(() => this.initDatatables(), 100)
        })
        .catch((err) => this.$helper.catchHandler(err))
      setTimeout(() => this.initDatatables(), 100)
    },
    submit () {
      this.$store.dispatch('sendBulkMessageToNewsletterSubscribers', this.bulkMessage)
        .then((result) => {
          this.$toast.success(result.data.message)
          $('.close').click()
          this.bulkMessage.subject = ''
          this.bulkMessage.message = ''
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
        })
    },
    deleteNewsletter (id) {
      this.$confirm(
        {
          message: `Are you sure you want to delete this query?`,
          button: { no: 'No', yes: 'Yes' },
          callback: confirm => {
            if (confirm) {
              this.$store.dispatch('deleteNewsletter', id)
                .then((result) => {
                  this.$toast.success(result.data.message)
                  this.fetchAllNewsletters()
                })
                .catch((err) => this.$toast.error(err.response.data.message))
            }
          }
        }
      )
    },
    updateSelectedComment (comment, title) {
      this.modal.title = title
      this.modal.comment = comment
    },
    searchDatatable (e) {
      this.datatable.search(e.target.value).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        stateSave: true,
        pagingType: 'full_numbers',
        columnDefs: [
          {
            targets: 3,
            'orderable': false
          }
        ],
        stateSaveCallback: function (settings, data) {
          localStorage.setItem('DataTables_accounts_page', JSON.stringify(data))
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(localStorage.getItem('DataTables_accounts_page'))
        },
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html("<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Newsletters.vue